// @flow

import S3API from 'api/S3API';

export const getCreds = (file_name: string, file_key: string, file_ext: string, bucket: string) => {
  if( file_name === '' || file_key === '' || file_ext === '' ) return false;

  return(dispatch: any) => {
    return S3API.getCreds(file_name, file_key, file_ext, bucket);
  }
}

export const uploadFile = (bucket: string, data: any, callbackProgress: any) => {
 return S3API.uploadFile(bucket, data);
}

export const saveAttachment = (data: any) => {
  return S3API.saveAttachment(data);
}

export const getFile = (hash: string) => {
  return S3API.getFile(hash);
}



// WEBPACK FOOTER //
// ./src/actions/s3/fileUpload.js